export const Greeting =() => {
    const date = new Date(Date.now());
    const hours = date.getHours();
    let timeOfDay;
    if (hours < 12) {
      timeOfDay = "Morning";
    } else if (hours >= 12 && hours < 16) {
      timeOfDay = "Afternoon";
    }
    else if (hours >= 16  && hours < 21) {
      timeOfDay = "Evening";
    }
     else {
      timeOfDay = "Night";
      return <>Good {timeOfDay}, Admin</>
    }
    return <>Hello, Good {timeOfDay}</>
  }